import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  type UrlTree,
} from '@angular/router';
import { snapshot } from '@principle-theorem/shared';
import { AuthGuard } from './auth-guard';
import { AuthService } from './auth.service';
import { WorkspaceService } from './workspace.service';

@Injectable({
  providedIn: 'root',
})
export class HasWorkspaceGuard extends AuthGuard {
  constructor(
    private _router: Router,
    auth: AuthService,
    private _workspace: WorkspaceService
  ) {
    super(auth);
  }

  async canActivate(
    _next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    const storedWorkspace: string | undefined = await snapshot(
      this._workspace.workspace$
    );

    if (storedWorkspace) {
      return true;
    }

    return this._router.createUrlTree(['/workspaces'], {
      queryParams: { redirectTo: state.url },
    });
  }
}
